import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export type AudienceMode = "creator" | "brand";

/**
 * Reads/writes the landing page's Creator|Brand toggle from the `?mode=` query
 * param so campaign links can deep-link straight into the brand view.
 */
export function useAudienceMode(): [AudienceMode, (mode: AudienceMode) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const mode: AudienceMode = searchParams.get("mode") === "brand" ? "brand" : "creator";

  const setMode = useCallback(
    (next: AudienceMode) => {
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev);
          params.set("mode", next);
          return params;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return [mode, setMode];
}
